import {
  ComponentDesignUploadFile,
  FeaturePatternTrussSettings,
  ProfileTrussSettings,
} from '@paragon/contract-library';

import { DesignService } from '../connections';
import { DownloadableFileResponse } from '../responses';

export function exportComponentDesign(componentDesignGuid: string): Promise<DownloadableFileResponse> {
  return DesignService.fetchFile(`revit/export/${componentDesignGuid}`);
}

export function extractFeaturePatternSettings(files: ComponentDesignUploadFile[]) {
  return DesignService.post<readonly FeaturePatternTrussSettings[]>('revit/extractFeaturePatternSettings', {
    data: files,
  });
}

export function extractProfileSettings(files: ComponentDesignUploadFile[]) {
  return DesignService.post<readonly ProfileTrussSettings[]>('revit/extractProfileSettings', { data: files });
}
